import { render, staticRenderFns } from "./shopManage.vue?vue&type=template&id=0ece1fa0&scoped=true"
import script from "./shopManage.vue?vue&type=script&lang=ts"
export * from "./shopManage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ece1fa0",
  null
  
)

export default component.exports